<template>
  <div>
    <!-- Create Ticket Modal -->
    <b-modal
      v-model="showCreateTicketModal"
      title="Create Ticket"
      size="lg"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <validation-observer ref="formRules">
        <b-form
          enctype="multipart/form-data"
          @submit.prevent="handleFormSubmit($event)"
          @keydown.enter="$event.preventDefault()"
        >
          <div class="row">
            <!-- Left Column -->
            <div class="col-md-6">
              <b-col md="12">
                <b-form-group>
                  <label><strong>Service Type</strong></label
                  ><span style="color: red">*</span>
                  <validation-provider
                    #default="{ errors }"
                    name="Service Type"
                    rules="required"
                  >
                    <v-select
                      v-model="form.service_type"
                      @input="fetchProblems"
                      :reduce="(status) => status.value"
                      :options="serviceType"
                      placeholder="Select Service Type"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <span class="text-danger text-sm" v-if="be_errors['service_type']">
                    <small>{{ be_errors["service_type"][0] }}</small>
                  </span>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group>
                  <label><strong>Problem</strong></label
                  ><span style="color: red">*</span>
                  <validation-provider
                    #default="{ errors }"
                    name="Problem"
                    rules="required"
                  >
                    <v-select
                      v-model="form.problem"
                      @input="fetchServiceLines"
                      :options="filteredProblems"
                      :reduce="(problem) => problem.id"
                      label="name"
                      placeholder="Select Problem"
                      :clearable="true"
                      :searchable="true"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <span class="text-danger text-sm" v-if="be_errors['problem']">
                    <small>{{ be_errors["problem"][0] }}</small>
                  </span>
                </b-form-group>
              </b-col>

              <b-col
                md="12"
                v-if="form.service_type === 'isp' || form.service_type === 'iptv'"
              >
                <b-form-group>
                  <label><strong>Service Line</strong></label
                  ><span style="color: red">*</span>
                  <validation-provider
                    #default="{ errors }"
                    name="Service Line"
                    :rules="
                      form.service_type === 'isp' || form.service_type === 'iptv'
                        ? 'required'
                        : ''
                    "
                  >
                    <v-select
                      v-model="form.service_line"
                      :options="serviceLines"
                      :reduce="(line) => line.id"
                      label="name"
                      placeholder="Select Service Line"
                      :clearable="true"
                      :searchable="true"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <span class="text-danger text-sm" v-if="be_errors['service_line']">
                    <small>{{ be_errors["service_line"][0] }}</small>
                  </span>
                </b-form-group>
              </b-col>
            </div>
            <!-- Right Column -->
            <div class="col-md-6">
              <b-col md="12">
                <b-form-group>
                  <label><strong>Service Address</strong></label>
                  <textarea
                    class="form-control"
                    name="address"
                    v-model="form.address"
                    disabled
                  ></textarea>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <label><strong> Description/Remarks </strong></label>
                  <textarea
                    class="form-control"
                    name="private_note"
                    v-model="form.private_note"
                  ></textarea>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <label>
                    <strong>Priority </strong><span style="color: red">*</span>
                  </label>
                  <select
                    class="form-control"
                    name="priority"
                    v-model="form.priority"
                    required
                  >
                    <option value="3">High</option>
                    <!-- Add more priority levels if needed -->
                  </select>
                </b-form-group>
              </b-col>
            </div>
          </div>
          <!-- Save -->
          <b-row>
            <b-col
              md="12"
              class="d-flex justify-content-center"
              style="margin-top: 1.7rem"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                type="submit"
                class="mr-1"
              >
                Create </b-button
              >&nbsp;&nbsp;
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="info"
                @click="resetForm()"
              >
                Clear
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Ticket Summary Tables -->
        <b-row>
          <b-col cols="12" sm="6" class="d-flex justify-content-sm-start mt-1">
            <span class="text-muted">
              <b-form-group
                class="mb-0 d-flex align-items-center justify-content-between"
              >
                <div class="d-flex align-items-center">
                  <label class="mr-2 mb-0">Per Page</label>
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage"
                    size="sm"
                    :options="perPageOptions"
                    class="w-auto"
                  />
                  <label class="mb-0">&nbsp;Total {{ dataMeta.of }} entries</label>
                </div>
              </b-form-group>
            </span>
          </b-col>

          <!-- Create Ticket Button -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end mt-1"
          >
            <b-button
              variant="primary"
              class="mb-2"
              @click="showCreateTicketModal = true"
            >
              <feather-icon icon="PlusIcon" />
              Create Ticket
            </b-button>
          </b-col>
        </b-row>

        <b-table
          ref="refComplainListTable"
          sticky-header="500px"
          :select-mode="selectMode"
          class="position-relative"
          :items="sortedComplains"
          responsive
          :fields="tableColumns"
          primary-key="(row) => row.username + row.callingstationid"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(sl)="data">
            <span>{{ currentPage * perPage - perPage + data.index + 1 }}</span>
          </template>
          <template #cell(ticket_number)="data">
            {{ data.item.ticket_number }}
          </template>

          <template #cell(service_type)="data">
            {{
              data.item.service_type === "isp"
                ? "MiME Internet"
                : data.item.service_type === "iptv"
                ? "MiME TV"
                : data.item.service_type === "iptsp"
                ? "MiME Talk"
                : ""
            }}
          </template>

          <template #cell(level)="data">
            {{ data.item.complexity_level && data.item.complexity_level.level }}
          </template>
          <template #cell(created)="data">
            {{ data.item.created | formatLocalDateTime }}
          </template>
          <template #cell(deadline)="data">
            {{ data.item.deadline | formatLocalDateTime }}
          </template>
          <template #cell(closing_date)="data">
            {{ data.item.closing_date | formatLocalDateTime }}
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                {{ dataMeta.of }} entries</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalComplains"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormCheckbox,
  BFormSelect,
  BFormGroup,
  BModal,
  BForm, // Ensure BForm is registered for <b-form>
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted, getCurrentInstance, onMounted } from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import useCustomerComplainList from "../../store/customers/useCustomerComplainList";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { decrypt } from "@/utils/crypto";
import api from "@/services/api";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { checkPermission } from "@/utils/helpers";
extend("required", required);

export default {
  components: {
    //EmployeesListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    BFormSelect,
    BFormGroup,
    BModal,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BForm,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      general_config: {
        wrap: true,
        altFormat: "d/m/Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      serviceType: [
        { label: "MiME Internet", value: "isp" },
        { label: "MiME TV", value: "iptv" },
        { label: "Kothon", value: "kothon" },
        { label: "MiME Talk", value: "iptsp" },
      ],
      filter: {
        fromDate: null,
        toDate: null,
        searchQuery: null,
      },
      ticketSummary: null, // Holds API summary data
      loadingSummary: false,
      selectMode: "multi",
      selected: [],
      showCreateTicketModal: false,
      form: {
        service_type: "",
        problem: "",
        service_line: "",
        address: "",
        private_note: "",
        priority: "3",
      },
      problems: [],
      filteredProblems: [],
      serviceLines: [],
      be_errors: {},
      loading: false,
      customerSearch: "",
    };
  },
  setup() {
    const defaultSelected = [];
    const departmentOptions = [];

    const {
      sortedComplains,
      loadComplains,
      tableColumns,
      perPage,
      currentPage,
      totalComplains,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refComplainListTable,
      refetchData,

      // UI
      resolveEmployeeStatusVariant,
      setFilter,
      // Extra Filters
    } = useCustomerComplainList();

    onMounted(() => {
      loadComplains();
    });

    // Expose ticketSummary and loadingSummary from data() to template
    // by using Vue's getCurrentInstance
    const vm =
      typeof getCurrentInstance === "function" ? getCurrentInstance()?.proxy : null;
    return {
      // Sidebar
      defaultSelected,
      sortedComplains,
      loadComplains,
      tableColumns,
      perPage,
      currentPage,
      totalComplains,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refComplainListTable,
      refetchData,
      // Filter
      checkPermission,
      // UI
      resolveEmployeeStatusVariant,
      setFilter,
      // Extra Filters
      selected: [],
      selectMode: "multi",
      ticketSummary: vm ? vm.ticketSummary : null,
      loadingSummary: vm ? vm.loadingSummary : false,
    };
  },
  methods: {
    async handleFormSubmit() {
      this.$refs.formRules.validate().then(async (success) => {
        if (success) {
          const loader = this.$showCustomLoader();
          const userData = decrypt(localStorage.getItem("userData"));
          const profile_id = userData ? userData.profile_id : null;

          this.be_errors = {};
          try {
            // Prepare parameters
            const payload = {
              service_type: this.form.service_type,
              problem_id: this.form.problem,
              pending_reason_id: "1",
              service_line: this.form.service_line,
              customer_id: `${profile_id}`,
              service_address: this.form.address || "",
              description: this.form.private_note || "",
              priority: this.form.priority,
              problem_status: "New",
            };

            // POST request
            const response = await api.post(`/helpdesk/ticket_v2/`, payload);
            if (response.status === 201) {
              this.resetForm();
              this.showCreateTicketModal = false;
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "Success!",
                    text: "Ticket created successfully",
                    icon: "CheckIcon",
                    variant: "success",
                  },
                },
                {
                  timeout: 8000, // here in the 2nd argument
                }
              );
              await this.refetchData();
            }
          } catch (error) {
            if (error.response?.status === 422 && error.response?.data?.errors) {
              this.be_errors = error.response.data.errors;
            }
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Error!",
                  text:
                    error.response?.data?.message ||
                    "An error occurred while creating the ticket",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              },
              {
                timeout: 8000, // here in the 2nd argument
              }
            );
          } finally {
            loader.hide();
          }
        }
      });
    },

    async fetchProblems() {
      if (!this.form.service_type) {
        this.filteredProblems = [];
        return;
      }
      try {
        const res = await api.get("/api/v1/helpdesk/ticket-type/list/");
        this.problems = res.data || [];
        this.filteredProblems = this.problems.filter(
          (p) => p.service_type === this.form.service_type
        );
      } catch (err) {
        this.filteredProblems = [];
      }
    },

    async fetchServiceLines() {
      if (!this.form.problem) {
        this.serviceLines = [];
        this.form.service_line = "";
        return;
      }

      const userData = decrypt(localStorage.getItem("userData"));
      const username = userData ? userData.username : null;

      try {
        const res = await api.get(`/api/v1/customer/service-line/${username}/`);

        this.serviceLines = (res.data || [])
          .filter(line => line.service_name === this.form.service_type) // ✅ FILTER like old code
          .map((line) => {
            let packageText = line.package_name;

            // ✅ ONLY for ISP (same as your jQuery شرط)
            if (this.form.service_type === "isp" && line.bw_info) {
              const bw =
                line.bw_info.down_bandwidth_limit && line.bw_info.down_bandwidth_unit
                  ? `${line.bw_info.down_bandwidth_limit}${line.bw_info.down_bandwidth_unit}`
                  : "";

              packageText += bw ? ` (${bw})` : "";
            }

            return {
              id: line.id,
              name: packageText,
            };
          });

      } catch (err) {
        console.error("Service line fetch error:", err);
        this.serviceLines = [];
      }
    },

    setFormattedAddress() {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));

      if (!userDetails || !userDetails.detail_contact_address) return;

      const addr = userDetails.detail_contact_address;

      this.form.address =
        `Division: ${addr.division ?? ""}, ` +
        `District : ${addr.district ?? ""}, ` +
        `Area: ${addr.area ?? ""}, ` +
        `Location: ${addr.location ?? ""}, ` +
        `Address: ${addr.address ?? ""}`;
    },

    resetForm() {
      this.form = {
        service_type: "",
        problem: "",
        service_line: "",
        address: "",
        private_note: "",
        priority: "3",
      };
      this.be_errors = {};
    }

  },
  watch: {
    "form.service_type": {
      immediate: false,
      handler: function () {
        this.form.problem = "";
        this.form.service_line = "";
      },
    },
    showCreateTicketModal(val) {
      if (val) {
        this.setFormattedAddress(); // modal open হলে call হবে
      }
    }

  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
